// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Campagnes : même langage visuel que Notifications et B-book ===== */

/* rouge plus foncé que --danger, pour que le texte blanc atteigne un contraste de 4.5:1 */
.campaigns_page {
  --campaigns-danger: #B91C1C;
  --campaigns-success: #15803D;
}

[data-theme="dark"] .campaigns_page {
  --campaigns-danger: #F87171;
  --campaigns-success: #4ADE80;
}

/* la feuille de style globale supprime tous les outlines : on rend le focus clavier visible */
.campaigns_page :is(button, a, select, input):focus-visible,
.campaigns_page .campaigns_toggle .toggle-checkbox:focus-visible + .toggle-switch {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

.campaigns_page .campaigns_num {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

/* ----- structure de page ----- */

.campaigns_page .campaigns_title_row {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.campaigns_page_title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--text-primary);
}

.campaigns_page .campaigns_hint {
  margin: 0 0 16px;
  max-width: 75ch;
  font-size: 13px;
  line-height: 1.5;
  color: var(--text-secondary);
}

.campaigns_page .campaigns_card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  padding: 24px;
  margin-bottom: 24px;
}

/* ----- boutons : un seul principal, actions de ligne discrètes, actions destructives en rouge ----- */

.campaigns_page .campaigns_primary_button,
.campaigns_page .campaigns_secondary_button,
.campaigns_page .campaigns_row_button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 36px;
  padding: 0 16px;
  border-radius: var(--radius-sm);
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.campaigns_page .campaigns_primary_button {
  background-color: var(--primary);
  border: 1px solid var(--primary);
  color: #fff;
}

.campaigns_page .campaigns_primary_button:hover:not(:disabled) {
  background-color: var(--primary-hover);
  box-shadow: var(--shadow-sm);
}

.campaigns_page .campaigns_secondary_button,
.campaigns_page .campaigns_row_button {
  background-color: transparent;
  border: 1px solid var(--border);
  color: var(--text-primary);
}

.campaigns_page .campaigns_secondary_button:hover:not(:disabled),
.campaigns_page .campaigns_row_button:hover:not(:disabled) {
  background-color: var(--bg);
}

.campaigns_page .campaigns_row_button {
  min-height: 32px;
  padding: 0 12px;
  font-size: 13px;
}

.campaigns_page .campaigns_row_button:hover:not(:disabled) {
  border-color: var(--text-secondary);
}

.campaigns_page .campaigns_row_button_danger {
  color: var(--campaigns-danger);
  border-color: color-mix(in srgb, var(--campaigns-danger) 40%, transparent);
}

.campaigns_page .campaigns_row_button_danger:hover:not(:disabled) {
  background-color: var(--danger-light);
  border-color: var(--campaigns-danger);
}

.campaigns_page .campaigns_primary_button:disabled,
.campaigns_page .campaigns_secondary_button:disabled,
.campaigns_page .campaigns_row_button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.campaigns_page .campaigns_row_actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

/* ----- liste ----- */

.campaigns_page .campaigns_toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.campaigns_page .campaigns_toolbar select {
  min-height: 36px;
  background-color: var(--bg);
  cursor: pointer;
}

.campaigns_page .campaigns_list_name {
  font-weight: 600;
  color: var(--text-primary);
}

/* début de la description sur une ligne, le texte complet au survol */
.campaigns_page .campaigns_list_description {
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: var(--text-secondary);
}

.campaigns_page .campaigns_type_cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.campaigns_page .campaigns_type_summary {
  font-size: 12px;
  color: var(--text-secondary);
  white-space: nowrap;
}

.campaigns_page .campaigns_chip,
.campaigns_page .campaigns_status {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.campaigns_page .campaigns_chip {
  background-color: var(--primary-light);
  color: var(--primary);
}

.campaigns_page .campaigns_status_running {
  background-color: var(--success-light);
  color: var(--campaigns-success);
}

.campaigns_page .campaigns_status_upcoming {
  background-color: var(--primary-light);
  color: var(--primary);
}

.campaigns_page .campaigns_status_ended {
  background-color: var(--bg);
  color: var(--text-secondary);
}

/* le tableau partagé coupe chaque cellule (layout fixe + ellipsis) : ici il prend la largeur nécessaire et défile horizontalement */
.campaigns_page .tableau_container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.campaigns_page .tableau_table {
  table-layout: auto;
  width: 100%;
}

.campaigns_page .tableau_head_item_th,
.campaigns_page .tableau_body_item {
  overflow: visible;
  text-overflow: clip;
}

.campaigns_page .tableau_body_item:last-child,
.campaigns_page .tableau_head_item_th:last-child {
  text-align: right;
}

.campaigns_page .campaigns_pager {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 12px;
  font-size: 13px;
  color: var(--text-secondary);
}

/* ----- états vide et erreur ----- */

.campaigns_page .campaigns_empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 16px;
  text-align: center;
  color: var(--text-secondary);
  border: 1px dashed var(--border);
  border-radius: var(--radius-md);
}

.campaigns_page .campaigns_empty_title {
  margin: 0;
  font-weight: 600;
  color: var(--text-primary);
}

.campaigns_page .campaigns_empty_hint {
  margin: 0;
  max-width: 60ch;
  font-size: 13px;
}

.campaigns_page .campaigns_empty_error {
  color: var(--campaigns-danger);
  background-color: var(--danger-light);
  border-style: solid;
  border-color: color-mix(in srgb, var(--campaigns-danger) 30%, transparent);
}

.campaigns_page .campaigns_empty_error .campaigns_empty_title {
  color: inherit;
}

/* ----- formulaire de création ----- */

.campaigns_page .modal-container {
  max-width: 100%;
}

.campaigns_page .campaigns_form_title {
  margin: 0 48px 8px 0; /* laisse la place au bouton de fermeture */
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
}

.campaigns_page .campaigns_form_section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 0;
  border-top: 1px solid var(--border);
}

.campaigns_page .campaigns_form_section h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
}

.campaigns_page .campaigns_field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.campaigns_page .campaigns_field_row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  align-items: start;
}

/* plafond + « Sans plafond » : la case s'aligne sur le champ, sous le libellé */
.campaigns_page .campaigns_field_row_end > .campaigns_checkbox {
  justify-self: start;
  min-height: 40px;
  margin-top: 25px;
}

.campaigns_page .campaigns_field_label {
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.campaigns_page .campaigns_field > input,
.campaigns_page .campaigns_field > select,
.campaigns_page .campaigns_field_control input {
  width: 100%;
  min-height: 40px;
  background-color: var(--bg);
}

.campaigns_page .campaigns_field > select {
  cursor: pointer;
}

.campaigns_page .campaigns_field > textarea {
  width: 100%;
  background-color: var(--bg);
  resize: vertical;
}

.campaigns_page .campaigns_field_control {
  position: relative;
}

.campaigns_page .campaigns_field_control input {
  padding-right: 32px;
  font-variant-numeric: tabular-nums;
  -moz-appearance: textfield; /* les flèches du champ nombre recouvrent l'unité */
}

.campaigns_page .campaigns_field_control input::-webkit-inner-spin-button,
.campaigns_page .campaigns_field_control input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.campaigns_page .campaigns_field_control input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.campaigns_page .campaigns_field_unit {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: var(--text-secondary);
  pointer-events: none;
}

.campaigns_page .campaigns_field [aria-invalid="true"] {
  border-color: var(--campaigns-danger);
}

.campaigns_page .campaigns_field [aria-invalid="true"]:focus {
  box-shadow: 0 0 0 3px var(--danger-light);
}

.campaigns_page .campaigns_field_helper,
.campaigns_page .campaigns_field_error {
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
}

.campaigns_page .campaigns_field_helper {
  color: var(--text-secondary);
}

.campaigns_page .campaigns_field_error {
  color: var(--campaigns-danger);
  font-weight: 500;
}

/* date de début d'une campagne en cours, qui ne peut plus changer */
.campaigns_page .campaigns_readonly_value {
  margin: 0;
  padding: 8px 0;
  font-size: 14px;
  color: var(--text-secondary);
}

.campaigns_page .campaigns_fieldset {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  border: none;
}

.campaigns_page .campaigns_checkbox_group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.campaigns_page .campaigns_checkbox {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 14px;
  color: var(--text-primary);
  cursor: pointer;
}

.campaigns_page .campaigns_checkbox:has(input:checked) {
  border-color: var(--primary);
  background-color: var(--primary-light);
}

.campaigns_page .campaigns_checkbox input {
  margin: 0;
  accent-color: var(--primary);
  cursor: pointer;
}

.campaigns_page .campaigns_switch_row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.campaigns_page .campaigns_switch_row p {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.campaigns_page .campaigns_switch_row + .campaigns_field_helper {
  margin-top: -10px;
}

.campaigns_page .campaigns_toggle {
  position: relative;
}

/* le toggle partagé masque sa case avec visibility, ce qui la retire aussi du clavier : on la garde focusable, juste invisible */
.campaigns_page .campaigns_toggle .toggle-checkbox {
  visibility: visible;
  opacity: 0;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
  z-index: 1;
}

.campaigns_page .campaigns_form_actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid var(--border);
}

.campaigns_page .campaigns_form_actions .campaigns_field_error {
  flex: 1 1 100%;
  text-align: right;
}

@media (prefers-reduced-motion: reduce) {
  .campaigns_page *,
  .campaigns_page *::before,
  .campaigns_page *::after {
    transition-duration: 0.01ms !important;
  }
}

@media (max-width: 768px) {
  .campaigns_page .campaigns_card {
    padding: 16px;
  }

  .campaigns_page .campaigns_field_row {
    grid-template-columns: minmax(0, 1fr);
  }

  .campaigns_page .campaigns_field_row_end > .campaigns_checkbox {
    margin-top: 0;
    justify-self: start;
  }

  .campaigns_page .campaigns_form_actions button {
    flex: 1 1;
  }

  .campaigns_page .campaigns_form_actions .campaigns_field_error {
    text-align: left;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/campaigns/campaigns.css"],"names":[],"mappings":"AAAA,4EAA4E;;AAE5E,0FAA0F;AAC1F;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,8FAA8F;AAC9F;;EAEE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gCAAgC;EAChC,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;;AAEA,uGAAuG;;AAEvG;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,uFAAuF;AACzF;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;;EAEE,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,0EAA0E;AAC5E;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA,sBAAsB;;AAEtB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,sEAAsE;AACtE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,oIAAoI;AACpI;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA,qCAAqC;;AAErC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,mBAAmB;EACnB,0EAA0E;AAC5E;;AAEA;EACE,cAAc;AAChB;;AAEA,uCAAuC;;AAEvC;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB,EAAE,2CAA2C;EACjE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B,EAAE,mDAAmD;AACjF;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iIAAiI;AACjI;EACE,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;;;IAGE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* ===== Campagnes : même langage visuel que Notifications et B-book ===== */\n\n/* rouge plus foncé que --danger, pour que le texte blanc atteigne un contraste de 4.5:1 */\n.campaigns_page {\n  --campaigns-danger: #B91C1C;\n  --campaigns-success: #15803D;\n}\n\n[data-theme=\"dark\"] .campaigns_page {\n  --campaigns-danger: #F87171;\n  --campaigns-success: #4ADE80;\n}\n\n/* la feuille de style globale supprime tous les outlines : on rend le focus clavier visible */\n.campaigns_page :is(button, a, select, input):focus-visible,\n.campaigns_page .campaigns_toggle .toggle-checkbox:focus-visible + .toggle-switch {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n.campaigns_page .campaigns_num {\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n/* ----- structure de page ----- */\n\n.campaigns_page .campaigns_title_row {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.campaigns_page_title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--text-primary);\n}\n\n.campaigns_page .campaigns_hint {\n  margin: 0 0 16px;\n  max-width: 75ch;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.campaigns_page .campaigns_card {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background-color: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n/* ----- boutons : un seul principal, actions de ligne discrètes, actions destructives en rouge ----- */\n\n.campaigns_page .campaigns_primary_button,\n.campaigns_page .campaigns_secondary_button,\n.campaigns_page .campaigns_row_button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 36px;\n  padding: 0 16px;\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  font-weight: 600;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.campaigns_page .campaigns_primary_button {\n  background-color: var(--primary);\n  border: 1px solid var(--primary);\n  color: #fff;\n}\n\n.campaigns_page .campaigns_primary_button:hover:not(:disabled) {\n  background-color: var(--primary-hover);\n  box-shadow: var(--shadow-sm);\n}\n\n.campaigns_page .campaigns_secondary_button,\n.campaigns_page .campaigns_row_button {\n  background-color: transparent;\n  border: 1px solid var(--border);\n  color: var(--text-primary);\n}\n\n.campaigns_page .campaigns_secondary_button:hover:not(:disabled),\n.campaigns_page .campaigns_row_button:hover:not(:disabled) {\n  background-color: var(--bg);\n}\n\n.campaigns_page .campaigns_row_button {\n  min-height: 32px;\n  padding: 0 12px;\n  font-size: 13px;\n}\n\n.campaigns_page .campaigns_row_button:hover:not(:disabled) {\n  border-color: var(--text-secondary);\n}\n\n.campaigns_page .campaigns_row_button_danger {\n  color: var(--campaigns-danger);\n  border-color: color-mix(in srgb, var(--campaigns-danger) 40%, transparent);\n}\n\n.campaigns_page .campaigns_row_button_danger:hover:not(:disabled) {\n  background-color: var(--danger-light);\n  border-color: var(--campaigns-danger);\n}\n\n.campaigns_page .campaigns_primary_button:disabled,\n.campaigns_page .campaigns_secondary_button:disabled,\n.campaigns_page .campaigns_row_button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.campaigns_page .campaigns_row_actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n/* ----- liste ----- */\n\n.campaigns_page .campaigns_toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.campaigns_page .campaigns_toolbar select {\n  min-height: 36px;\n  background-color: var(--bg);\n  cursor: pointer;\n}\n\n.campaigns_page .campaigns_list_name {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* début de la description sur une ligne, le texte complet au survol */\n.campaigns_page .campaigns_list_description {\n  max-width: 260px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n.campaigns_page .campaigns_type_cell {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.campaigns_page .campaigns_type_summary {\n  font-size: 12px;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.campaigns_page .campaigns_chip,\n.campaigns_page .campaigns_status {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.campaigns_page .campaigns_chip {\n  background-color: var(--primary-light);\n  color: var(--primary);\n}\n\n.campaigns_page .campaigns_status_running {\n  background-color: var(--success-light);\n  color: var(--campaigns-success);\n}\n\n.campaigns_page .campaigns_status_upcoming {\n  background-color: var(--primary-light);\n  color: var(--primary);\n}\n\n.campaigns_page .campaigns_status_ended {\n  background-color: var(--bg);\n  color: var(--text-secondary);\n}\n\n/* le tableau partagé coupe chaque cellule (layout fixe + ellipsis) : ici il prend la largeur nécessaire et défile horizontalement */\n.campaigns_page .tableau_container {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.campaigns_page .tableau_table {\n  table-layout: auto;\n  width: 100%;\n}\n\n.campaigns_page .tableau_head_item_th,\n.campaigns_page .tableau_body_item {\n  overflow: visible;\n  text-overflow: clip;\n}\n\n.campaigns_page .tableau_body_item:last-child,\n.campaigns_page .tableau_head_item_th:last-child {\n  text-align: right;\n}\n\n.campaigns_page .campaigns_pager {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 12px;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n/* ----- états vide et erreur ----- */\n\n.campaigns_page .campaigns_empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 32px 16px;\n  text-align: center;\n  color: var(--text-secondary);\n  border: 1px dashed var(--border);\n  border-radius: var(--radius-md);\n}\n\n.campaigns_page .campaigns_empty_title {\n  margin: 0;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.campaigns_page .campaigns_empty_hint {\n  margin: 0;\n  max-width: 60ch;\n  font-size: 13px;\n}\n\n.campaigns_page .campaigns_empty_error {\n  color: var(--campaigns-danger);\n  background-color: var(--danger-light);\n  border-style: solid;\n  border-color: color-mix(in srgb, var(--campaigns-danger) 30%, transparent);\n}\n\n.campaigns_page .campaigns_empty_error .campaigns_empty_title {\n  color: inherit;\n}\n\n/* ----- formulaire de création ----- */\n\n.campaigns_page .modal-container {\n  max-width: 100%;\n}\n\n.campaigns_page .campaigns_form_title {\n  margin: 0 48px 8px 0; /* laisse la place au bouton de fermeture */\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.campaigns_page .campaigns_form_section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 20px 0;\n  border-top: 1px solid var(--border);\n}\n\n.campaigns_page .campaigns_form_section h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.campaigns_page .campaigns_field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.campaigns_page .campaigns_field_row {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n  align-items: start;\n}\n\n/* plafond + « Sans plafond » : la case s'aligne sur le champ, sous le libellé */\n.campaigns_page .campaigns_field_row_end > .campaigns_checkbox {\n  justify-self: start;\n  min-height: 40px;\n  margin-top: 25px;\n}\n\n.campaigns_page .campaigns_field_label {\n  padding: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.campaigns_page .campaigns_field > input,\n.campaigns_page .campaigns_field > select,\n.campaigns_page .campaigns_field_control input {\n  width: 100%;\n  min-height: 40px;\n  background-color: var(--bg);\n}\n\n.campaigns_page .campaigns_field > select {\n  cursor: pointer;\n}\n\n.campaigns_page .campaigns_field > textarea {\n  width: 100%;\n  background-color: var(--bg);\n  resize: vertical;\n}\n\n.campaigns_page .campaigns_field_control {\n  position: relative;\n}\n\n.campaigns_page .campaigns_field_control input {\n  padding-right: 32px;\n  font-variant-numeric: tabular-nums;\n  -moz-appearance: textfield; /* les flèches du champ nombre recouvrent l'unité */\n}\n\n.campaigns_page .campaigns_field_control input::-webkit-inner-spin-button,\n.campaigns_page .campaigns_field_control input::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.campaigns_page .campaigns_field_control input:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.campaigns_page .campaigns_field_unit {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 14px;\n  color: var(--text-secondary);\n  pointer-events: none;\n}\n\n.campaigns_page .campaigns_field [aria-invalid=\"true\"] {\n  border-color: var(--campaigns-danger);\n}\n\n.campaigns_page .campaigns_field [aria-invalid=\"true\"]:focus {\n  box-shadow: 0 0 0 3px var(--danger-light);\n}\n\n.campaigns_page .campaigns_field_helper,\n.campaigns_page .campaigns_field_error {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.campaigns_page .campaigns_field_helper {\n  color: var(--text-secondary);\n}\n\n.campaigns_page .campaigns_field_error {\n  color: var(--campaigns-danger);\n  font-weight: 500;\n}\n\n/* date de début d'une campagne en cours, qui ne peut plus changer */\n.campaigns_page .campaigns_readonly_value {\n  margin: 0;\n  padding: 8px 0;\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.campaigns_page .campaigns_fieldset {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n  border: none;\n}\n\n.campaigns_page .campaigns_checkbox_group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.campaigns_page .campaigns_checkbox {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 36px;\n  padding: 0 12px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  color: var(--text-primary);\n  cursor: pointer;\n}\n\n.campaigns_page .campaigns_checkbox:has(input:checked) {\n  border-color: var(--primary);\n  background-color: var(--primary-light);\n}\n\n.campaigns_page .campaigns_checkbox input {\n  margin: 0;\n  accent-color: var(--primary);\n  cursor: pointer;\n}\n\n.campaigns_page .campaigns_switch_row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.campaigns_page .campaigns_switch_row p {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.campaigns_page .campaigns_switch_row + .campaigns_field_helper {\n  margin-top: -10px;\n}\n\n.campaigns_page .campaigns_toggle {\n  position: relative;\n}\n\n/* le toggle partagé masque sa case avec visibility, ce qui la retire aussi du clavier : on la garde focusable, juste invisible */\n.campaigns_page .campaigns_toggle .toggle-checkbox {\n  visibility: visible;\n  opacity: 0;\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  cursor: pointer;\n  z-index: 1;\n}\n\n.campaigns_page .campaigns_form_actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 20px;\n  border-top: 1px solid var(--border);\n}\n\n.campaigns_page .campaigns_form_actions .campaigns_field_error {\n  flex: 1 1 100%;\n  text-align: right;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .campaigns_page *,\n  .campaigns_page *::before,\n  .campaigns_page *::after {\n    transition-duration: 0.01ms !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .campaigns_page .campaigns_card {\n    padding: 16px;\n  }\n\n  .campaigns_page .campaigns_field_row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .campaigns_page .campaigns_field_row_end > .campaigns_checkbox {\n    margin-top: 0;\n    justify-self: start;\n  }\n\n  .campaigns_page .campaigns_form_actions button {\n    flex: 1;\n  }\n\n  .campaigns_page .campaigns_form_actions .campaigns_field_error {\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
